export const getCollection = (state, id) => state.collections.find((collection) => collection.id === id);
